import React from "react";
import { motion } from "framer-motion";
import { fadeUp } from "../../lib/motion";
import { ArrowRight } from "lucide-react";

export default function FinalCTA() {
  return (
    <section data-testid="final-cta-section" className="py-28 sm:py-40">
      <div className="max-w-5xl mx-auto px-6 sm:px-8 text-center">
        <motion.div {...fadeUp}>
          <p className="overline mb-8">— Ready?</p>
          <h2 className="font-serif-display font-medium text-4xl sm:text-6xl tracking-tight text-[color:var(--charcoal)] leading-[1.05]">
            Your business should feel
            <br />
            <span className="italic text-[color:var(--gold)]">structured, not overwhelming.</span>
          </h2>
          <p className="mt-10 max-w-xl mx-auto text-lg text-[color:var(--text-secondary)] font-light">
            One application. Everything set up properly.
          </p>
          <a href="#enquire" data-testid="final-cta-button" className="btn-primary mt-12 inline-flex">
            Apply to Work Together <ArrowRight size={14} strokeWidth={1.25} />
          </a>
          <p className="mt-8 overline" data-testid="final-cta-scarcity">
            — By application only · Limited spots each month
          </p>
        </motion.div>
      </div>
    </section>
  );
}
